/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable react/display-name */
import React, {
  memo,
  useState,
  useEffect,
  forwardRef,
  ForwardedRef,
} from 'react';

import { SearchAutoCompleteContent } from '@wconcept/wconcept-ui-renewal/@types/search';
import {
  IconLogout01,
  LogoWcon02,
  IconLogin01,
  IconHeart04,
  IconMy02,
  IconCart02,
} from '@wconcept/wconcept-ui-renewal/components/atoms/svg';
import Button from '@wconcept/wconcept-ui-renewal/components/atoms/Button';
import Title from '@wconcept/wconcept-ui-renewal/components/atoms/Title';
import Count from '@wconcept/wconcept-ui-renewal/components/molecules/Count';
import CateAreaDesktop from '@wconcept/wconcept-ui-renewal/components/molecules/_desktop/CateAreaDesktop';
import SchAreaDesktop from '@wconcept/wconcept-ui-renewal/components/molecules/_desktop/SchAreaDesktop';
import MainGnbMenuBarItem from '@wconcept/wconcept-ui-renewal/components/molecules/_item/MainGnbMenuBarItem';
import {
  SearchKeywordInfo,
  PopularKeywordInfo,
} from '@wconcept/wconcept-common/models/renewal/search';
import { classNameBind } from '@wconcept/wconcept-common/utils/commonUtils';

import {
  GnbPcInfo,
  GnbPcMegaMenuInfo,
  LargeCategory,
  MiddleCategory,
  NewGnbInfo,
  PcGnbCategoryInfo,
} from '@wconcept/wconcept-common/models/renewal/gnb';
import { LnbV2Menu } from '@wconcept/wconcept-common/models/renewal/lnb';
import { Brand } from '@wconcept/wconcept-common/models/display/search';
import * as S from './style';

interface IProps {
  /** className */
  className?: string;
  /** megaMenu */
  megaMenu?: GnbPcMegaMenuInfo;
  gnbPcInfo?: GnbPcInfo;
  /** gnbInfo */
  gnbInfo: NewGnbInfo[];
  /** basketCount */
  basketCount: number;
  /** isNativeAppBoth */
  isNativeAppBoth: boolean;
  /** keyword */
  keyword?: string;
  /** recentSearchKeywordsList */
  recentSearchKeywordsList: string;
  /** isDesktop */
  isDesktop: boolean;
  /** isLogin */
  isLogin: boolean;
  /** searchPopularWords */
  searchPopularWords: PopularKeywordInfo;
  /** searchInitInfo */
  searchInitInfo: SearchKeywordInfo;
  /** searchAutoKeywordInfo */
  searchAutoKeywordInfo: SearchAutoCompleteContent;
  /** onClickGnbMenu */
  onClickGnbMenu: (gnbInfo: NewGnbInfo, i: number) => void;
  /** onClickLogo */
  onClickLogo: () => void;
  /** onClickJoin */
  onClickJoin: () => void;
  /** onClickLogin */
  onClickLogin: () => void;
  /** onClickLogout */
  onClickLogout: () => void;
  /** onClickHeart */
  onClickHeart: () => void;
  /** onClickMyPage */
  onClickMyPage: () => void;
  /** onClickCart */
  onClickCart: () => void;
  /** onClickMediumCategory */
  onClickMediumCategory: (pcGnbCategoryInfo: PcGnbCategoryInfo) => void;
  /** onClickLargeCategory */
  onClickLargeCategory: (
    pcGnbCategoryInfo: PcGnbCategoryInfo,
    largeCategory: LargeCategory
  ) => void;
  /** onClickMiddleCategory */
  onClickMiddleCategory: (
    pcGnbCategoryInfo: PcGnbCategoryInfo,
    largeCategory: LargeCategory,
    middleCategory: MiddleCategory
  ) => void;
  /** onPressEnter */
  onPressEnter: (value: string, recentKeywords: string[]) => void;
  /** onClickAutoSearchResult */
  onClickAutoSearchResult: (
    value: string,
    type: string,
    recentKeywordResult: string[],
    item?: Brand,
    no?: number
  ) => void;
  /** onSearchClick */
  onSearchClick?: (
    e: HTMLInputElement,
    recentKeywordsList: string[],
    searchInitInfo?: SearchKeywordInfo
  ) => void;
  /** onKeywordClick */
  onKeywordClick: (
    param: string,
    type: string,
    recentKeywords: string[],
    no: number
  ) => void;
  /** requestAutoComplete */
  requestAutoComplete?: (keyword: string) => void;
  /** requestSearchPopularWords */
  requestSearchPopularWords?: () => void;
  /** onClickLnbMenu */
  onClickLnbMenu?: (lnbData: LnbV2Menu, type: string) => void;
}

const HeaderDesktop = forwardRef(
  (
    {
      className = '',
      megaMenu,
      gnbPcInfo,
      gnbInfo,
      basketCount,
      isNativeAppBoth,
      keyword,
      recentSearchKeywordsList,
      isDesktop,
      isLogin,
      searchPopularWords,
      searchAutoKeywordInfo,
      searchInitInfo,
      onClickGnbMenu,
      onClickLnbMenu,
      onClickLogo,
      onClickJoin, // eslint-disable-line @typescript-eslint/no-unused-vars -- props 인터페이스 호환용
      onClickLogin,
      onClickLogout,
      onClickHeart,
      onClickMyPage,
      onClickCart,
      onClickMediumCategory,
      onClickLargeCategory,
      onClickMiddleCategory,
      onPressEnter,
      onClickAutoSearchResult,
      onSearchClick,
      onKeywordClick,
      requestAutoComplete,
      requestSearchPopularWords,
    }: IProps,
    ref: ForwardedRef<HTMLDivElement>
  ) => {
    // 검색 컨트롤 관련
    const [isSearchOpen, setIsSearchOpen] = useState(false);

    const [count, setCount] = useState<number>(0);
    // GA4

    useEffect(() => {
      setCount(Number(basketCount));
    }, [basketCount]);
    //= ================== ITEM HANDLER ======================

    return (
      <S.HeaderDesktop
        ref={ref}
        className={classNameBind(['header-desktop', className || ''])}
        id="headerDesktop"
      >
        <nav className="inner-nav">
          <div className="innv-row-01">
            {/* 로고 */}
            <Title level={1} className="area-logo">
              <Button
                onClick={onClickLogo}
                label="W컨셉"
                icon={<LogoWcon02 />}
              />
            </Title>
            <ul className="nav-utils">
              {!isLogin && (
                <li className="login">
                  <Button
                    icon={<IconLogin01 />}
                    label="로그인"
                    onClick={onClickLogin}
                  />
                </li>
              )}
              {isLogin && (
                <li className="logout">
                  <Button
                    icon={<IconLogout01 />}
                    label="로그아웃"
                    onClick={onClickLogout}
                  />
                </li>
              )}

              <li className="heart">
                <Button
                  icon={<IconHeart04 />}
                  label="좋아요"
                  onClick={onClickHeart}
                />
              </li>
              <li className="my">
                <Button
                  icon={<IconMy02 />}
                  label="마이페이지"
                  onClick={onClickMyPage}
                />
              </li>
              <li className="cart">
                <Button
                  icon={<IconCart02 />}
                  label="장바구니 바로가기"
                  onClick={onClickCart}
                >
                  <Count
                    label={`${count}개의 상품이 담겨 있습니다.`}
                    count={count}
                  />
                </Button>
              </li>
            </ul>
          </div>
          <div className="innv-row-02">
            {/* 메뉴 */}
            <div className="area-nav">
              <ul className="nav-gnb" id="nav-main">
                {gnbInfo
                  ?.filter(gnb => gnb.pcGnbLocation === 'LEFT')
                  .map((v, i) => (
                    <li key={`${v.landingUrl}+${v.menuTitle}`}>
                      <MainGnbMenuBarItem
                        text={v.menuTitle}
                        dot={v.highlightType === 'POINT'}
                        textColor={
                          v.highlightType === 'COLOR' ? v.highlightColor : ''
                        }
                        isAd={v.adYn === 'Y'}
                        imgSrc={
                          v.highlightType === 'IMAGE'
                            ? v.highlightDefaultImageUrl
                            : undefined
                        }
                        lottieData={
                          v.highlightType === 'LOTTIE_JSON'
                            ? v.highlightDefaultImageUrl
                            : undefined
                        }
                        onClick={() => {
                          onClickGnbMenu(v, i);
                        }}
                      />
                    </li>
                  ))}
              </ul>
              {gnbInfo &&
                gnbInfo?.filter?.(gnb => gnb.pcGnbLocation === 'RIGHT').length >
                  0 && (
                  <ul className="nav-gnb2">
                    {gnbInfo
                      ?.filter(gnb => gnb.pcGnbLocation === 'RIGHT')
                      .map((v, i) => (
                        <li key={`${v.landingUrl}+${v.menuTitle}`}>
                          <MainGnbMenuBarItem
                            text={v.menuTitle}
                            dot={v.highlightType === 'POINT'}
                            textColor={
                              v.highlightType === 'COLOR'
                                ? v.highlightColor
                                : ''
                            }
                            isAd={v.adYn === 'Y'}
                            imgSrc={
                              v.highlightType === 'IMAGE'
                                ? v.highlightDefaultImageUrl
                                : undefined
                            }
                            lottieData={
                              v.highlightType === 'LOTTIE_JSON'
                                ? v.highlightDefaultImageUrl
                                : undefined
                            }
                            onClick={() => {
                              onClickGnbMenu(v, i);
                            }}
                          />
                        </li>
                      ))}
                  </ul>
                )}
            </div>

            {/* 검색 */}
            <SchAreaDesktop
              keyword={keyword}
              isNativeAppBoth={isNativeAppBoth}
              recentSearchKeywordsList={recentSearchKeywordsList}
              isSearchOpen={isSearchOpen}
              onPressEnter={onPressEnter}
              searchInitInfo={searchInitInfo}
              searchClose={() => setIsSearchOpen(false)}
              onClickAutoSearchResult={onClickAutoSearchResult}
              onSearchClick={onSearchClick}
              onKeywordClick={onKeywordClick}
              searchPopularWords={searchPopularWords}
              requestAutoComplete={requestAutoComplete}
              requestSearchPopularWords={requestSearchPopularWords}
              searchAutoKeywordInfo={searchAutoKeywordInfo}
              isDesktop={isDesktop}
            />

            {/* 카테고리 */}
            <CateAreaDesktop
              category={megaMenu?.categories ?? gnbPcInfo?.category}
              themes={megaMenu?.themes}
              quickMenus={megaMenu?.quickMenus}
              onClickMediumCategory={onClickMediumCategory}
              onClickLargeCategory={onClickLargeCategory}
              onClickMiddleCategory={onClickMiddleCategory}
              onClickLnbMenu={onClickLnbMenu}
            />
          </div>
        </nav>
      </S.HeaderDesktop>
    );
  }
);

export default memo(HeaderDesktop);
